export interface LoginProviderBadge {
  id: string;
  label: string;
}

export const UNWEE_PROVIDER_LEGEND =
  'Via UnWee : Microsoft, Google ou compte local UnWee';

export const STATIC_UNWEE_PROVIDERS: LoginProviderBadge[] = [
  { id: 'microsoft', label: 'Microsoft' },
  { id: 'google', label: 'Google' },
  { id: 'local', label: 'Compte local UnWee' },
];

function ProviderMark({ id }: { id: string }) {
  const key = id.toLowerCase();
  if (key === 'microsoft') {
    return (
      <svg className="h-3.5 w-3.5 shrink-0" viewBox="0 0 21 21" aria-hidden="true">
        <rect fill="#F25022" x="1" y="1" width="9" height="9" />
        <rect fill="#7FBA00" x="11" y="1" width="9" height="9" />
        <rect fill="#00A4EF" x="1" y="11" width="9" height="9" />
        <rect fill="#FFB900" x="11" y="11" width="9" height="9" />
      </svg>
    );
  }
  if (key === 'google') {
    return (
      <svg className="h-3.5 w-3.5 shrink-0" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="#4285F4"
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        />
        <path
          fill="#34A853"
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        />
        <path
          fill="#FBBC05"
          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        />
        <path
          fill="#EA4335"
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        />
      </svg>
    );
  }
  if (key === 'local') {
    return (
      <svg className="h-3.5 w-3.5 shrink-0" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="#6B7280"
          d="M7 14a5 5 0 1 1 4.9-6H21v3h-2v2h-2v2h-3.1A5 5 0 0 1 7 14zm0-2.2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
        />
      </svg>
    );
  }
  return null;
}

/** Pastilles informatives. Pas de bouton, pas de lien : le choix se fait sur UnWee. */
export function UnweeProviderBadges({
  providers,
}: {
  providers: LoginProviderBadge[];
}) {
  const list = providers.length > 0 ? providers : STATIC_UNWEE_PROVIDERS;
  return (
    <div className="mt-3">
      <p className="text-center text-xs text-gray-500">{UNWEE_PROVIDER_LEGEND}</p>
      <ul
        aria-label={UNWEE_PROVIDER_LEGEND}
        className="mt-2 flex flex-wrap items-center justify-center gap-2"
      >
        {list.map((provider) => (
          <li
            key={provider.id}
            className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-gray-100 px-2.5 py-1 text-xs text-gray-700"
          >
            <ProviderMark id={provider.id} />
            <span>{provider.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
